import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { FeedbackHost } from './feedback';
import DictHost from './DictHost';
import UpdateBanner, { announceUpdate } from './updateBanner';
import ImageViewer from './ImageViewer';
import reportWebVitals from './reportWebVitals';
import { startStudyTimer } from './activityLog';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
    <DictHost />
    <ImageViewer />
    <FeedbackHost />
    <UpdateBanner />
  </React.StrictMode>
);

// 新版 service worker：不自動重新載入（會中斷作答），只在畫面上提示，使用者按「立即更新」才換版。
// 按下後請新版接手（SKIP_WAITING），接手完成再重新載入一次；沒有按就維持目前版本，下次重新開啟 App 時自然換新。
let updateRequested = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (updateRequested) window.location.reload();
  });
}

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    announceUpdate(() => {
      updateRequested = true;
      if (registration.waiting) registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      else window.location.reload();
    });
  },
});

startStudyTimer();
reportWebVitals();
